import { render, staticRenderFns } from "./page-job-detail.vue?vue&type=template&id=fa391b4c&"
import script from "./page-job-detail.vue?vue&type=script&lang=js&"
export * from "./page-job-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports